import { TEMPLATE_GALLERY } from '@confluence/named-routes/entry-points/routes.ts';

const TEMPLATE_GALLERY_TAB_BLOCK = 'block';

export const getSnippetShareUrl = (shareId: string, snippetId: string): string => {
	return TEMPLATE_GALLERY.toUrl(
		{},
		{ query: { tab: TEMPLATE_GALLERY_TAB_BLOCK, shareId, snippetId } },
	);
};

export const getTemplateGallerySnippetUrl = (
	snippetId: string,
	spaceKey: string | null | undefined,
): string => {
	const query: Record<string, string> = {
		tab: TEMPLATE_GALLERY_TAB_BLOCK,
		template: snippetId,
	};
	if (spaceKey && spaceKey.trim()) {
		query.space = spaceKey.trim();
	}
	return TEMPLATE_GALLERY.toUrl({}, { query });
};
